import { render, staticRenderFns } from "./Okome.vue?vue&type=template&id=be9e25fe&scoped=true&lang=pug&"
import script from "./Okome.vue?vue&type=script&lang=js&"
export * from "./Okome.vue?vue&type=script&lang=js&"
import style0 from "./Okome.vue?vue&type=style&index=0&id=be9e25fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9e25fe",
  null
  
)

export default component.exports